import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=16252ff4&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=ts"
export * from "./IndexPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16252ff4",
  null
  
)

export default component.exports